// eslint-disable-next-line max-len
import { fit } from '@cloudinary/url-gen/actions/resize';
import { Cloudinary } from '@cloudinary/url-gen';
import { ExternalMedia, UnsavedExternalMedia } from '../../../../structures/models/media/external';
import { Media, UnsavedMedia } from '../../../../structures/models/media/media';

export type AllCloudinaryMedia = Media | UnsavedMedia;
export type AllExternalMedia = ExternalMedia | UnsavedExternalMedia;
export type AllMedia = AllCloudinaryMedia | AllExternalMedia;
/**
 * consumes media and sorts it based on sort_id.
 * @param allMedia
 */
export const sortMedia = (allMedia: Array<AllMedia>): Array<AllMedia> => {
  return allMedia.sort((obj1: AllMedia, obj2: AllMedia) => {
    return (obj1.sort_id > obj2.sort_id) ? 1 : 0;
  });
};

/**
 * consumes an array of videos, images, and externalVideos and sorts them according to sort_id
 * @param videoMedia
 * @param imageMedia
 * @param externalVideoMedia
 */
export const combineAndSortImages = (
  videoMedia: Array<AllCloudinaryMedia>,
  imageMedia: Array<AllCloudinaryMedia>,
  externalVideoMedia: Array<AllExternalMedia>,
):
  Array<AllMedia> => {
  let allMedia: Array<AllMedia> = [];
  allMedia = allMedia.concat(videoMedia);
  allMedia = allMedia.concat(imageMedia);
  allMedia = allMedia.concat(externalVideoMedia);
  allMedia = sortMedia(allMedia);
  return allMedia;
};

/**
 * generates a thumbnail url to be used in the cloudinary widgets.
 * this thumbnail url will request a 264X264 image from cloudinary.
 *
 * Resizing images via cloudinary url is helpful because it diminishes load time
 * @param media
 * @param cloudinaryUrlObj
 */
export const getThumbnailUrl = (media: AllMedia, cloudinaryUrlObj: Cloudinary): string => {
  let imageUrl = '';
  if ((media as AllCloudinaryMedia).public_id) {
    const publicId = (media as AllCloudinaryMedia).public_id;
    const thumbnailImage = cloudinaryUrlObj.image(publicId);
    thumbnailImage
      .resize(
        fit()
          .width(264)
          .height(264),
      );
    imageUrl = thumbnailImage.toURL();
  } else if ((media as AllExternalMedia).resource_link) {
    imageUrl = (media as AllExternalMedia).resource_link;
  }
  return imageUrl;
};

export const isCloudinaryMedia = (obj: any): obj is AllCloudinaryMedia => {
  return obj
    && obj.file_url !== undefined
    && obj.public_id !== undefined
    && obj.file_name !== undefined
    && obj.file_type !== undefined
    && obj.sort_id !== undefined
    && obj.size !== undefined;
};
